import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth, formatApiError } from "@/lib/auth";
import { toast } from "sonner";

export default function Login() {
  const nav = useNavigate();
  const loc = useLocation();
  const { login } = useAuth();
  const [email, setEmail] = useState(loc.state?.prefillEmail || "");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Signed in");
      nav("/agency");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      <div className="hidden md:block md:w-1/2 relative overflow-hidden">
        <img
          src="https://images.pexels.com/photos/1170412/pexels-photo-1170412.jpeg"
          alt="Modern office"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-slate-900/30" />
        <div className="relative z-10 p-12 flex flex-col justify-between h-full text-white">
          <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
            <div className="w-10 h-10 rounded-xl bg-white p-1 flex items-center justify-center shadow-lg">
              <img src="/logo-mark.png" alt="Foliosy" className="w-full h-full object-contain" />
            </div>
            <span className="font-bold text-xl">Foliosy</span>
          </Link>
          <div>
            <p className="eyebrow text-white/70 mb-3">Agency Operating System</p>
            <h2 className="text-4xl font-bold leading-tight">Ship client portals. Sign contracts. Get referrals.</h2>
          </div>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <h1 className="text-4xl font-bold tracking-tight text-slate-900 mb-2">Welcome back</h1>
          <p className="text-slate-600 mb-8">Sign in to your agency dashboard.</p>

          <label className="text-sm font-medium text-slate-700 mb-1.5 block">Email</label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 mb-4 focus:bg-white focus:ring-2 focus:ring-slate-900/5 focus:border-slate-900 outline-none"
            data-testid="login-email-input"
          />

          <label className="text-sm font-medium text-slate-700 mb-1.5 block">Password</label>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Demo12345!"
            className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 mb-6 focus:bg-white focus:ring-2 focus:ring-slate-900/5 focus:border-slate-900 outline-none"
            data-testid="login-password-input"
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-slate-900 text-white rounded-full py-3 font-medium hover:bg-slate-700 active:scale-95 disabled:opacity-50"
            data-testid="login-submit-button"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>

          <p className="mt-6 text-sm text-slate-600">
            Don't have an agency?{" "}
            <Link to="/register" className="text-slate-900 font-medium underline" data-testid="go-register-link">
              Create one
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
